import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlidesWideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M18 4H2V16H6V20H22V8H18V4ZM3.5 14.5H6V8H16.5V5.5H3.5V14.5ZM11 14.75V13.25H13.25V11H14.75V13.25H17V14.75H14.75V17H13.25V14.75H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesWideAdd;
